import type { FaireProductEntity } from "../../entity_types/product";

export const p_zq7g2sbp4e: FaireProductEntity = {
  token: "p_zq7g2sbp4e",
  type: "product",
  name: "Hooded Double Button Baby Coat Jacket (Organic) 4 Colors",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl: "https://cdn.faire.com/fastly/51185a4932d9115e5969b32887092146e770e19b00ea0f8359899f4243b63fdd.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a1ea35d6271861513f2ee77c9e830459f08a8563301d763a103386f1f8bed7d6.png",
    "https://cdn.faire.com/fastly/0f45f647aa8eef0d592cedc3b90a102d8fb803c84a1fc5bbce50ef8c1c5448c6.png",
    "https://cdn.faire.com/fastly/aec6a40495fbed89eebd8825ccb4121b0750b6163141e62140bc4953c3f0922f.jpeg",
    "https://cdn.faire.com/fastly/38042ef24a283bb7667e70f545919579606324a601e057d1e2cb75c17d75574a.jpeg",
    "https://cdn.faire.com/fastly/f5804c354070bd88f5654238192157aa86931f552e4e7e82585525e79872946c.png",
    "https://cdn.faire.com/fastly/102b890704899a8b4c7ae7001f902aad50fd707db229d47859fe41333088d629.png",
    "https://cdn.faire.com/fastly/0b93902a04a94151073a821a9e4eb6736b49aad8fd628a423c6867e98a75d420.jpeg",
    "https://cdn.faire.com/fastly/a8a684125d35d633d5ea43037efc145673b67937c53fb10a107b7786607386df.jpeg",
    "https://cdn.faire.com/fastly/3bcf23a5c526732fa7061bcd302e5f35f266046bb8cb968b0cd1a31312861f36.jpeg",
    "https://cdn.faire.com/fastly/0d22717e8565c93141504a655e346c529ff3043c34a0e7dae32ce07e3bc99b14.jpeg",
    "https://cdn.faire.com/fastly/e6f20c40ab7e28566f00971cff636837eab67f5605c3e17b4fbd1897cfccf417.png",
    "https://cdn.faire.com/fastly/d81c88a063f9010f86d22e4b2eb9463d97da57773aa8b267f9dfde2b498c7a6c.png",
    "https://cdn.faire.com/fastly/1f5266c224af75566587932b3c590943bd798eb4a05c4012a1acfa73bc9b425a.png",
    "https://cdn.faire.com/fastly/f4c90aeb4151d79028ce4618c8ffd641404e45f2c66d2a36c6d9fdd2b817169d.png"
  ],
  priceDollars: 25,
  description: "Keep your little one cozy and stylish in our organic cotton fine sweater knit hooded jacket! Made with love and care for both your baby and the planet. Ethically made in India.\nDouble breasted design with large hood, chunky knit style.\n• 100% organic cotton, chunky & adorable sweater knit baby jacket.\n• Long sleeves, hooded top, front pocket.\n• Double wooden button closure in front.\n• Lightweight, soft, all-season and comfy.\n• Classic and adorable design with meticulous detailing.\n• Harsh chemicals free & non-toxic formulation, eco-friendly.\n• Ethically produced in India, supporting better livelihoods for small grower farmers.\n\n• Baby Sweater Knit Pants  (Organic) SKU 230768, SKU 230761\n• Embroidered Knit Bow Baby Headband (Organic)  5 Colors SKU 230770",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:27.032Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
